
	// IMPORTS
	import { defineComponent, PropType, onMounted, onBeforeUnmount } from 'vue'
	import { Dialog } from '@progress/kendo-vue-dialogs'

	export default defineComponent({
		name: 'AppDialog',

		components: {
			'k-dialog': Dialog
		},

		props: {
			title: { type: String as PropType<string>, required: true }
		},

		emits: ['close'],

		setup(props, { emit }) {
			/********************************************************************************************************************
			 EVENT HANDLERS
			 ********************************************************************************************************************/
			function onKeyDown(e: KeyboardEvent) {
				if (e.key === 'Escape') {
					e.stopPropagation()
					emit('close')
				}
			}

			/********************************************************************************************************************
			 LIFECYCLE
			 ********************************************************************************************************************/
			onMounted(() => {
				document.addEventListener('keydown', onKeyDown)
			})

			onBeforeUnmount(() => {
				document.removeEventListener('keydown', onKeyDown)
			})

			return {}
		}
	})
